/* eslint-disable */
export const slugManager = (slug: string, node_locale: string) => {
  switch (node_locale) {
    case 'en':
      return `${slug}`;
    default:
      return `/${node_locale}${slug}`;
  }
};
